import * as svg from "../../../assets/chevron-up-icon.svg";

import {iconBuilder} from "./iconBuilder";

export const ChevronUpIcon = iconBuilder(svg, "ChevronUpIcon", "0 0 24 24");
